import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography, IconButton, Tooltip, Drawer, Menu, MenuItem } from "@mui/material";
import '../../Laboratory/Purchase/purchase.css';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { AmountFormat, CheckAccessFunc, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import { CommonGridToolBarWithFilterTextCustom } from "../../../Components/Common Components/CommonComponents";
import { CurrencySymbol } from "../../../Utility/Constants";
import { AmountsCard } from "../../../Components/CommonCards/CommonCards";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import CommonDatePicker from "../../../Components/Common Components/CommonDatePicker";
import { DateTime } from "luxon";
import { localGetItem } from "../../../Utility/Services/CacheProviderService";

const InsuranceProvider = () => {
    const { t } = useTranslation();
    const [InsuranceData, setInsuranceData] = useState([]);
    const [pageSize, setPageSize] = useState(30);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoader, setIsLoader] = useState(false);
    const [states, setStates] = useState({
        totalClaimAmount: 0,
        totalPatientPaidAmount: 0,
        totalReceivedAmount: 0,
        totalOutstanding: 0,
        totalCount: 0,
        disableBtn: false,
        pageLength: 0
    });
    const [Filter, setFilter] = useState({
        openFilter: false,
        fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        dateIndex: 1,
    });
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [printMenuAnchor, setPrintMenuAnchor] = useState(null);
    const [excelMenuAnchor, setExcelMenuAnchor] = useState(null);
    const history = useHistory();

    useEffect(() => {
        getInsuranceList();
    }, []);

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const msgClose = () => {
        seterrorMsgText('');
        seterrorMsg(false);
    }

    const getInsuranceList = (fromDate = Filter.fromDate, toDate = Filter.toDate) => {
        try {
            setIsLoader(true);
            setInsuranceData([]);

            RestAPIService.getAll(`${Serviceurls.INSURANCE_PROVIDER_GET}?from_date=${fromDate}&to_date=${toDate}`)
                .then(response => {
                    if (response.data.status === "success") {
                        const list = response.data.data?.map((item, i) => ({ ...item, sno: i + 1 })) || [];
                        setInsuranceData(list || []);
                        setStates(prev => ({
                            ...prev,
                            totalCount: response.data?.total_count || 0,
                            totalClaimAmount: response.data?.total_claimed_amount || 0,
                            totalOutstanding: response.data?.total_pending_amount || 0,
                            totalReceivedAmount: response.data?.total_received_amount || 0,
                            pageLength: response.data?.no_of_pages || 0
                        }));
                    }
                    setIsLoader(false);
                })
                .catch(error => {
                    setIsLoader(false);
                    if (error.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message)
            setIsLoader(false);
        }
    };

    const handleView = (event, values) => {
        history.push({ pathname: "/CreditSettlement/Insurance/Payment", state: { companyData: values?.row, fromDate: Filter.fromDate, toDate: Filter.toDate, dateIndex: Filter.dateIndex, AllData: (Filter.fromDate == '' && Filter.toDate == '') ? true : false } });
    };

    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const closeFilter = () => {
        setFilter(prev => ({ ...prev, openFilter: false }));
    }

    const FilterDate = (fromDate, toDate, dateIndex) => {
        setFilter(prev => ({
            ...prev,
            fromDate: fromDate,
            toDate: toDate,
            dateIndex: dateIndex
        }));
    }

    const renderFilterScreen = () => {
        const org_id = JSON.parse(localGetItem("org_id"));
        return (
            <Box component="div" className='eMed_rts_filter_container'>
                <Box component="div" className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t('Filter')}</Typography>
                    <Button
                        emed_tid="vndpay_close"
                        onClick={() => setFilter(prev => ({ ...prev, openFilter: false }))}
                        className='eMed_usrconf_btn'
                    >
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>

                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter_vendor'>
                        {
                            org_id === 707 ? // without restriction date filter works for kkr alone
                                <CommonDatePicker
                                    FromDate={Filter.fromDate}
                                    ToDate={Filter.toDate}
                                    DateIndex={Filter.dateIndex}
                                    SelectedDates={FilterDate}
                                    HideAllMenu={false}
                                /> :
                                <CommonDatePicker
                                    FromDate={Filter.fromDate}
                                    ToDate={Filter.toDate}
                                    DateIndex={Filter.dateIndex}
                                    SelectedDates={FilterDate}
                                    HideAllMenu={true}
                                    OutOfOffice={true}
                                    Past={true}
                                    Future={false}
                                    FromDateOpen="2026-03-22"   // <-- Dont change this date it will affect the Insurace Reports
                                />
                        }
                    </Box>
                </Box>

                <Stack spacing={2} direction="row" className='eMed_rts_btn' alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small" emed_tid="fil_clear"
                        onClick={() => {
                            const clearedFilter = {
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                openFilter: false
                            };

                            setFilter(clearedFilter);
                            getInsuranceList(DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'), DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'));
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Clear")}
                    </Button>
                    <Button
                        variant='contained'
                        size="small"
                        emed_tid="fil_search"
                        onClick={() => {
                            getInsuranceList();
                            setFilter(prev => ({ ...prev, openFilter: false }));
                        }}
                        id="eMed_Config_btn"
                    >
                        {t("Search")}
                    </Button>
                </Stack>
            </Box>
        );
    };


    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(Filter.fromDate) },
            { label: "To Date", value: formatDate(Filter.toDate) },
        ]
        var ExportData = [];
        InsuranceData?.length > 0 && InsuranceData.map((item) => {
            const InsuData = {
                "Insurance Provider": item?.insurance_company_name,
                "No Of Admissions": item?.count,
                "Claim Amount": item?.claim_amount,
                "Received Amount": item?.credit_paid,
                "Outstanding Amount": item?.pending_amount,
            };
            ExportData.push(InsuData);
        });
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Insurance Provider"} FilterTextArray={TextArray} filename={"Insurance Provider"} />
            </Box>
        )
    }

    const printInsuPaymentList = () => {
        try {
            setPrintMenuAnchor(null);
            setStates(prev => ({ ...prev, disableBtn: true }));
            RestAPIService.getAll(`${Serviceurls.UPDATED_INSU_PAYMENT_REPORT}?from_date=${Filter.fromDate}&to_date=${Filter.toDate}&clinic_id=${localGetItem("clinicId")}&export=pdf`)
                .then(response => {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates(prev => ({ ...prev, disableBtn: false }));
                })
                .catch(error => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error?.message);
                    }
                    setStates(prev => ({ ...prev, disableBtn: false }));
                });
        } catch (error) {
            errorMessage(error?.message);
            setStates(prev => ({ ...prev, disableBtn: false }));
        }
    };

    const printInsuSettlementReport = () => {
        try {
            setPrintMenuAnchor(null);
            setStates(prev => ({ ...prev, disableBtn: true }));
            RestAPIService.getAll(`${Serviceurls.INS_CREDIT_SETTLEMENT_REPORT}?from_date=${Filter.fromDate}&to_date=${Filter.toDate}&clinic_id=${localGetItem("clinicId")}&credit_type=Insurance credit&export=pdf`)
                .then(response => {
                    const file = new Blob([response.data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setStates(prev => ({ ...prev, disableBtn: false }));
                })
                .catch(error => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error?.message);
                    }
                    setStates(prev => ({ ...prev, disableBtn: false }));
                });
        } catch (error) {
            errorMessage(error?.message);
            setStates(prev => ({ ...prev, disableBtn: false }));
        }
    };

    const getInsuPaymentexcel = () => {
        try {
            RestAPIService.excelGet(`${Serviceurls.UPDATED_INSU_PAYMENT_REPORT}?from_date=${Filter.fromDate}&to_date=${Filter.toDate}&clinic_id=${localGetItem("clinicId")}&export=excel`)
                .then(response => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data;
                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'Credit Settlement Report.xlsx');
                        pom.click();
                    }
                }).catch(error => {
                    errorMessage(error?.response?.data?.message);
                });
        } catch (error) {
            errorMessage(error?.message);
        }
    };

    const printInsuSettlementExcelReport = () => {
        try {
            setPrintMenuAnchor(null);
            RestAPIService.excelGet(`${Serviceurls.INS_CREDIT_SETTLEMENT_REPORT}?from_date=${Filter.fromDate}&to_date=${Filter.toDate}&clinic_id=${localGetItem("clinicId")}&credit_type=Insurance credit&export=excel`)
                .then(response => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data;
                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'Credit Settlement Report.xlsx');
                        pom.click();
                    }
                }).catch(error => {
                    errorMessage(error?.response?.data?.message);
                });
        } catch (error) {
            errorMessage(error?.message);
        }
    };

    const RenderTable = () => {
        const columns = [
            { field: 'sno', headerName: 'S.No', flex: 0.01 },
            {
                field: 'insurance_company_name', headerClassName: 'grid--header', headerName: t('Insurance Provider'), flex: 0.23, sortable: false,
                renderCell: (params) => (<div>{params?.row?.insurance_company_name?.length > 33 ? <Tooltip placement="top" title={params?.row?.insurance_company_name} arrow>{params?.row?.insurance_company_name.slice(0, 30) + "..."}</Tooltip> : params?.row?.insurance_company_name || "-"}</div>)
            },
            {
                field: 'count', headerClassName: 'grid--header', headerName: t('No Of Admissions'), flex: 0.11, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.count || "0"}</div>)
            },
            {
                field: 'claim_amount', headerClassName: 'grid--header', headerName: `${t("Claim Amount")} (${CurrencySymbol})`, flex: 0.18, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.claim_amount ? (AmountFormat(params?.row?.claim_amount || 0).replace(`${CurrencySymbol}`, "")) : '0'}</div>)
            },
            {
                field: 'credit_paid', headerClassName: 'grid--header', headerName: `${t("Received Amount")} (${CurrencySymbol})`, flex: 0.18, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.credit_paid ? (AmountFormat(params?.row?.credit_paid || 0).replace(`${CurrencySymbol}`, "")) : "0"}</div>)
            },
            {
                field: 'pending_amount', headerClassName: 'grid--header', headerName: `${t("Outstanding Amount")} (${CurrencySymbol})`, flex: 0.18, sortable: false, type: "number",
                renderCell: (params) => (<div>{params?.row?.pending_amount ? (AmountFormat(params?.row?.pending_amount || 0).replace(`${CurrencySymbol}`, "")) : '0'}</div>)
            },
            {
                field: 'actions', headerClassName: 'grid--header', headerName: t('Action'), type: 'actions', flex: 0.105, sortable: false, hideable: false,
                renderCell: (cellvalues) => (
                    <>
                        {/* <Tooltip title={t("Print")} placement="top" arrow>
                        <div>
                            <Button emed_tid="Print_invoice" className='eMed_usrconf_btn' disabled={states.disableBtn} onClick={() => { getInsuDetailedBillPrint(cellvalues?.id) }}>
                                <img src={ImagePaths.PrintIcons.default} alt="cart" className='eMed_action_img' />
                            </Button>
                        </div>
                    </Tooltip> */}
                        <Tooltip title={t("Payback")} placement="top" arrow>
                            <IconButton disabled={!CheckAccessFunc("Front Office", "Settlement", "Insurance Provider", "Credit Payment", "SubTab")?.editAccess} size="small" sx={{ borderRadius: "0.3vw" }} onClick={(event) => handleView(event, cellvalues)}>
                                <img className="emedhub_vendor_img2" src={ImagePaths.Wallet.default} alt="Wallet" />
                            </IconButton>
                        </Tooltip>
                    </>
                )
            }
        ];
        return (
            <div id="emedhub_ventor_Table" style={{ margin: "0vw 1vw", height: "63vh" }}>
                <DataGrid
                    rows={InsuranceData}
                    columns={columns}
                    hideFooterSelectedRowCount
                    getRowId={(row) => row?.sno}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    onCellClick={handleCellClick}
                    onRowClick={handleCellClick}
                    page={currentPage}
                    loading={isLoader}
                    onPageChange={(newPage) => setCurrentPage(newPage)}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                />
            </div>
        )
    }

    return (
        <Box className="emedhub__purchase_page" sx={{ '& .grid--header': { backgroundColor: '#FAF9F9' } }}>
            <Box className='eMed_Pharma_rts_header'>
                <Box flex={0.8} display="flex">
                    {AmountsCard("Total Count", states.totalCount, true, "white", false, null)}
                    {AmountsCard("Total Claim", states.totalClaimAmount, false, "white", false, null)}
                    {AmountsCard("Total Received", states.totalReceivedAmount, false, "white", false, null)}
                    {AmountsCard("Total Outstanding", states.totalOutstanding, false, "white", false, null)}
                </Box>
                <Box flex={0.2} display="flex" justifyContent="flex-end" alignItems="center" marginRight="0.5vw">
                    <Tooltip title="Filter" placement='top' arrow>
                        <Button className='eMed_usrconf_btn' onClick={() => { setFilter(prev => ({ ...prev, openFilter: true })) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Tooltip>
                    {localGetItem('allow_manual_entry_in_credit_settlement') === 'true' ? <>
                        <Tooltip title="Export" placement='top' arrow>
                            <Button emed_tid="vndpay_print" onClick={(e) => setExcelMenuAnchor(e.currentTarget)} disabled={states.disableBtn} className='eMed_usrconf_btn'>
                                <img src={ImagePaths.ExportIcon.default} alt="upload" className='eMed_action_img' />
                            </Button>
                        </Tooltip>
                        <Menu anchorEl={excelMenuAnchor} open={Boolean(excelMenuAnchor)} onClose={() => setExcelMenuAnchor(null)}>
                            <MenuItem onClick={getInsuPaymentexcel}>{t("Excel Aging Report")}</MenuItem>
                            <MenuItem onClick={printInsuSettlementExcelReport}>{t("Excel Settlement Report")}</MenuItem>
                        </Menu>
                    </> : null}
                    {localGetItem('allow_manual_entry_in_credit_settlement') === 'true' ? <>
                        <Tooltip title="Print" placement="top" arrow>
                            <Button emed_tid="vndpay_print" className="eMed_usrconf_btn" disabled={states.disableBtn} onClick={(e) => setPrintMenuAnchor(e.currentTarget)}>
                                <img src={ImagePaths.LabPrintIcon.default} alt="print" className="eMed_action_img" style={{ height: '2.2vw', width: '2.2vw' }} />
                            </Button>
                        </Tooltip>
                        <Menu anchorEl={printMenuAnchor} open={Boolean(printMenuAnchor)} onClose={() => setPrintMenuAnchor(null)}>
                            <MenuItem onClick={printInsuPaymentList}>{t("Print Aging Report")}</MenuItem>
                            <MenuItem onClick={printInsuSettlementReport}>{t("Print Settlement Report")}</MenuItem>
                        </Menu>
                    </> : null}
                </Box>
            </Box>
            {RenderTable()}
            <Drawer
                anchor={'right'}
                open={Filter.openFilter}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
};

export default InsuranceProvider;
